/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-unresolved */
import { useMutation } from "react-query";
import { SET_TOAST_ERROR } from "src/redux/Actions/common";
import store from "src/redux/store";
import { saveAndUpdateRiderDetails } from "src/services/Riders";

export const useRiderDetailsMutation = (setFieldValue: any, riderValues: Record<string, any>[]) =>
  useMutation(saveAndUpdateRiderDetails, {
    onSuccess: (response) => {
      if (setFieldValue && response?.data) {
        const updatedRiderDetails = riderValues?.map((rider: Record<string, any>) => {
          const matched = response?.data?.find((res: any) => res?.riderId === rider?.riderId);
          return matched ? { ...rider, id: matched?.id } : rider;
        });
        setFieldValue("riderDetails", updatedRiderDetails);
      }
    },
    onError: (error: any) => {
      store.dispatch(
        SET_TOAST_ERROR({
          error: true,
          duration: 2000,
          message: error?.message || "Unable to save rider. Please try again"
        })
      );
    }
  });
